import React, { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Loader2 } from "lucide-react";
import { RefreshButton } from "@/components/RefreshButton";
import { Pager } from "@/components/Pager";
import { brl, fmtDT, METHOD, Badge, Header, CursoCurto } from "./common";

/** Financeiro → Transações: cada movimento informado pelo Mercado Pago. */
export default function Transactions() {
  const [data, setData] = useState(null);
  const [f, setF] = useState({ frm: "", to: "", status: "" });
  const [page, setPage] = useState(1);
  const load = useCallback(() => { setData(null); return api.get("/admin/finance/transactions", { params: { ...f, page, limit: 50 } }).then((r) => setData(r.data)).catch(() => setData({ total: 0, rows: [] })); }, [f, page]);
  useEffect(() => { load(); }, [load]);
  const set = (k, v) => { setPage(1); setF((p) => ({ ...p, [k]: v })); };
  return (
    <div className="space-y-5 animate-fade-up">
      <Header title="Transações" sub="Movimentos do Mercado Pago: aprovações, recusas, estornos e chargebacks." right={<RefreshButton onClick={load} />} />
      <div className="bg-white rounded-xl border border-slate-200 shadow-sm">
        <div className="p-4 flex flex-wrap gap-2 items-center border-b border-slate-100">
          <select value={f.status} onChange={(e) => set("status", e.target.value)} className="h-10 rounded-md border border-slate-200 bg-white px-3 text-sm">
            {[["", "Todas"], ["approved", "Aprovadas"], ["pending", "Pendentes"], ["in_process", "Em análise"], ["rejected", "Recusadas"], ["refunded", "Estornos"], ["charged_back", "Chargebacks"]].map(([v, l]) => <option key={v} value={v}>{l}</option>)}
          </select>
          <Input type="date" value={f.frm} onChange={(e) => set("frm", e.target.value)} className="h-10 w-40" />
          <Input type="date" value={f.to} onChange={(e) => set("to", e.target.value)} className="h-10 w-40" />
        </div>
        {data === null ? <div className="p-10 grid place-items-center"><Loader2 className="h-5 w-5 animate-spin text-slate-400" /></div> : data.rows.length === 0 ? (
          <p className="p-10 text-center text-slate-400 text-sm">Nenhuma transação. Elas aparecem quando o Mercado Pago avisa sobre um pagamento.</p>
        ) : (
          <div className="overflow-x-auto iep-scroll">
            <table className="w-full text-sm">
              <thead><tr className="text-left text-xs uppercase tracking-wide text-slate-500 bg-slate-50/60">
                <th className="px-4 py-3">Data</th><th className="px-3 py-3">ID Mercado Pago</th><th className="px-3 py-3 hidden md:table-cell">Curso</th><th className="px-3 py-3">Forma</th>
                <th className="px-3 py-3 text-right">Valor</th><th className="px-3 py-3 text-right hidden lg:table-cell">Taxa</th><th className="px-3 py-3 text-right hidden lg:table-cell">Líquido</th><th className="px-3 py-3">Situação</th></tr></thead>
              <tbody className="divide-y divide-slate-100">
                {data.rows.map((t) => (
                  <tr key={t.id}>
                    <td className="px-4 py-2.5 whitespace-nowrap text-slate-600">{fmtDT(t.at)}</td>
                    <td className="px-3 py-2.5 font-mono text-xs text-slate-500">{t.mp_payment_id}</td>
                    <td className="px-3 py-2.5 hidden md:table-cell text-slate-600"><CursoCurto titulo={t.course} /></td>
                    <td className="px-3 py-2.5 whitespace-nowrap text-slate-600">{METHOD[t.payment_type] || t.payment_type || "—"}{t.installments > 1 ? ` ${t.installments}x` : ""}</td>
                    <td className="px-3 py-2.5 text-right font-semibold">{brl(t.amount)}</td>
                    <td className="px-3 py-2.5 text-right hidden lg:table-cell text-amber-700">{brl(t.fee)}</td>
                    <td className="px-3 py-2.5 text-right hidden lg:table-cell">{brl(t.net)}</td>
                    <td className="px-3 py-2.5"><Badge status={t.status} label={t.status_label} />{t.status_detail && <div className="text-[10px] text-slate-400 mt-1">{t.status_detail}</div>}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <Pager page={page} perPage={50} total={data.total} onChange={setPage} />
          </div>
        )}
      </div>
    </div>
  );
}
